<template>
  <div class="smart-components-wrapper">
    <template v-for="(component, componentKey) in loopComponents">
      <component
        :data-hash="_.get(component, 'hashTag')"
        :is="component.selectedComponent"
        :key="component.selectedComponent + componentKey"
        :contentData="getContentData(component)"
        v-if="contentData_loaded"
      />
    </template>
  </div>
</template>

<script>
export default {
  name: "smartComponentsLoader",
  data() {
    return {
      hashName: "",
      top: false,
      contentData_loaded: false
    };
  },
  created() {
    let components = _.get(this.$store.state.main.indx, "smartComponents");

    for (let i in components) {
      // console.log('component: ', i);
      this.$options.components[i] = () =>
        import("../../components/smartComponents/" + i);
    }
  },
  mounted() {
    /*console.log(this.$route)*/
  },
  watch: {
    $route: {
      immediate: true,
      handler: function() {
        let _this = this;
        this.hashName = this.$route.hash.substring(1);
        setTimeout(function() {
          if (document.querySelector('[data-hash="' + _this.hashName + '"]')) {
            _this.top = document
              .querySelector('[data-hash="' + _this.hashName + '"]')
              .getBoundingClientRect().top;
          }

          if (
            _this.top &&
            _this.$mq != "tablet" &&
            _this.$mq != "phone" &&
            _this.$mq != "xs"
          ) {
            _this.$store.commit("setScrollTo", _this.top - 60);
          } else if (_this.top) {
            window.scrollTo({
              top: 5380,
              behavior: "smooth"
            });
          }
        }, 1000);
      }
    },
    request_status: {
      immediate: true,
      handler(ns) {
        if (ns === "done") {
          this.contentData_loaded = true;
        }
      }
    }
  },
  computed: {
    loopComponents() {
      let smartComponents = _.get(
        this.$store.state.main.selected_menu,
        "secondary_data"
      );
      let singleOrList = _.get(
        this.$store.state.main.selected_menu,
        "routeParams.singleview"
      )
        ? "single"
        : "list";
      let componentTitles = [];
      let ret = [];
      for (let i in smartComponents) {
        if (_.get(smartComponents[i], "enabled") != 1) continue;

        //// exclude component depend on menu settings
        if (
          singleOrList === "list" &&
          _.get(smartComponents[i], "listLayout") != 1
        ) {
          continue;
        } else if (
          singleOrList === "single" &&
          _.get(smartComponents[i], "singleLayout") != 1
        ) {
          continue;
        }

        ret.push(smartComponents[i]);
        componentTitles.push(smartComponents[i].selectedComponent);
        // console.log(i, smartComponents[i].selectedComponent, singleOrList, 'primary: '+_.get( smartComponents[i], 'primary'), smartComponents[i]);
      }
      /*        console.log('page components: ', _.map(ret, 'selectedComponent'), '; NOTE: if some component does not loads first check spelling and component exists!');*/
      return ret;
    },
    request_status() {
      return this.$store.state.main.current_content_request_status;
    }
  },
  methods: {
    getContentData(component) {
      let selectedComponent = _.get(component, "selectedComponent");
      let componentUnicId = _.get(component, "unicId");
      let primary = _.get(component, "primary");
      let res = {};
      // console.log(selectedComponent, componentUnicId, primary, _.get(this.$store.state.main.current_content, ["primary", 'data', 'listCount']) );

      if (
        primary &&
        _.get(this.$store.state.main.current_content, [
          "primary",
          "data",
          "listCount"
        ])
      ) {
        // console.log(component);
        res = _.get(this.$store.state.main.current_content, ["primary"]);
      }

      if (!_.get(res, "conf.enabled")) {
        res.conf = _.get(this.$store.state.main.current_content, [
          "secondary",
          selectedComponent + "_" + componentUnicId,
          "conf"
        ]);
      }
      if (!_.get(res, "data.listCount")) {
        res.data = _.get(this.$store.state.main.current_content, [
          "secondary",
          selectedComponent + "_" + componentUnicId,
          "data"
        ]);
      }
      // console.log(this.$store.state.main.current_content_request_status)
      return res;
    }
  }
};
</script>
<style lang="scss">
.smart-components-wrapper {
  overflow-x: hidden;
  overflow: hidden;
  min-height: 100vh;
  padding-top: 140px;
  @media (max-width: 767px) {
    padding-top: 88px;
  }
}
</style>
